// pages/AgendaPage.js o donde desees usarlo
import React from 'react';
import { Box } from '@mui/material';
import ManifiestosDashboardBase from '../../components/administration/manifests/ManifestDashboardBase';
import TaxiManifestDashboard from '../../components/operations/taxi/TaxiManifestDashboard';

const ManifiestosTaxiPage = () => {
    return (
        <Box sx={{ p: 2 }}>
            <TaxiManifestDashboard
                /*tipoServicioCodigo="TAXI"
                serProInt={false}
                title="Gestión de Taxis"*/
                onReorder={(newOrder) => {
                    console.log('Nuevo orden de Manifiestos Taxi', newOrder);
                }}
            />
        </Box>
    );
};

export default ManifiestosTaxiPage;
